import * as ActionTypes from '../constants/actiontypes/account';
import axios from 'axios';
import * as urls from '../constants/webapi/account';

export function fetchUser() {
    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_USER_REQUEST });
        return axios.get(urls.ACCOUNT_URL)
            .then((body) => {
                dispatch({
                    type: ActionTypes.FETCH_USER_SUCCESS,
                    data: body.data
                });
                return body.data;
            }).catch((error) => {
                if (error.response !== undefined && (error.response.status === 401 || error.response.status === 404)) {
                    window.location = urls.getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_USER_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function updateUser(user) {
    return (dispatch) => {
        dispatch({ type: ActionTypes.UPDATE_USER_REQUEST, user: user });
        return axios.put(urls.ACCOUNT_URL, { firstName: user.firstName, lastName: user.lastName, email: user.email, phoneNumber: user.phoneNumber, language: user.language })
            .then((body) => {
                dispatch({
                    type: ActionTypes.UPDATE_USER_SUCCESS,
                    data: body.data
                });
                return body;
            }).catch((error) => {
                if (error.response !== undefined && (error.response.status === 401 || error.response.status === 404)) {
                    window.location = urls.getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.UPDATE_USER_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function updatePassword(password) {
    return (dispatch) => {
        dispatch({ type: ActionTypes.UPDATE_PASSWORD_REQUEST, password: password });
        return axios.put(urls.PASSWORD_URL, { oldPassword: password.current, newPassword: password.new1 })
            .then((body) => {
                dispatch({
                    type: ActionTypes.UPDATE_PASSWORD_SUCCESS,
                    data: body.data
                });
                return body;
            }).catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = urls.getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.UPDATE_PASSWORD_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function deleteAccount() {
    return (dispatch) => {
        dispatch({ type: ActionTypes.DELETE_ACCOUNT_REQUEST });
        return axios.delete(urls.ACCOUNT_URL)
            .then((body) => {
                dispatch({
                    type: ActionTypes.DELETE_ACCOUNT_SUCCESS,
                    data: body.data
                });
                return body;
            }).catch((error) => {
                if (error.response !== undefined && (error.response.status === 401 || error.response.status === 404)) {
                    window.location = urls.getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.DELETE_ACCOUNT_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}

export function getApplications() {
    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_APPLICATIONS_REQUEST });
        return axios.get(urls.APPLICATIONS_URL)
            .then((body) => {
                dispatch({
                    type: ActionTypes.FETCH_APPLICATIONS_SUCCESS,
                    data: body.data
                });
                return body.data;
            }).catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = urls.getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_APPLICATIONS_FAILURE,
                    response: error.response
                });
                console.log(error);
                //throw error.statusText;
            });
    };
}

export function uploadProfileImage(profileImageContent) {
    let data = new FormData();
    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    };

    data.append("body", profileImageContent);

    return (dispatch) => {
        dispatch({ type: ActionTypes.UPLOAD_PROFILE_IMAGE_REQUEST });
        return axios.put(urls.PROFILE_IMAGE_URL, data, config)
            .then((response) => {
                dispatch({
                    type: ActionTypes.UPLOAD_PROFILE_IMAGE_SUCCESS,
                    data: response.data
                });
                return response;
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = urls.getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.UPLOAD_PROFILE_IMAGE_FAILURE,
                    response: error.response
                });
                throw error;
            });
    };
};

export function deleteProfileImage() {
    return (dispatch) => {
        dispatch({ type: ActionTypes.DELETE_PROFILE_IMAGE_REQUEST });
        return axios.delete(urls.PROFILE_IMAGE_URL)
            .then((response) => {
                dispatch({
                    type: ActionTypes.DELETE_PROFILE_IMAGE_SUCCESS,
                    data: response.data
                });
                return response;
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = urls.getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.DELETE_PROFILE_IMAGE_FAILURE,
                    response: error.response
                });
                throw error;
            });
    };
};